var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"货币"}},[_c('Currency')],1),_c('el-tab-pane',{attrs:{"label":"贸易费用"}},[_c('CostSet')],1),_c('el-tab-pane',{attrs:{"label":"职位"}},[_c('PositionSet')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }